module.exports = __webpack_public_path__ + "img/1.44b6fd2a.jpg";